import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {createPortal} from "react-dom";
import {
  checkFormValidity,
  handleDefaultValues,
} from "../../common/Utils";
import {useFieldArray, useForm} from 'react-hook-form';
import {useParams} from "react-router-dom";
import {
  getInventoryEvent,
  getPublicEventWaiver, submitGuestWaiver
} from "../../common/api/PortalCustomerApi";
import Meta from "../../common/Meta";
import {Card, CardContent, Divider, Grid} from "@mui/material";
import CustomerPageLayout from "../../Layout/CustomerPageLayout";
import CustomerHeader from "../../common/CustomerHeader";
import MDBox from "../../../components/MDBox";
import Footer from "../../Footer";
import {UserContext} from "../../../lib/UserProvider";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import {CONSTANTS} from "../../common/constants";
import MDInput from "../../../components/MDInput";
import {getCookie, setAppCookie} from "../../common/appCookie";
import {Col, Row} from "react-bootstrap";
import EsignatureField from "../waiver/EsignatureField";

export default function CustomerViewEventWaiver(props) {
  const [context, setContext] = useContext(AppContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [user, setUser] = useState();

  let {eventId} = useParams();
  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [stepOne, setStepOne] = useState(true);
  const [stepTwo, setStepTwo] = useState(false);
  const [stepThree, setStepThree] = useState(false);

  const [guests, setGuests] = useState([]);

  useEffect(() => {
    getInventoryEventFn();
  }, [eventId]);

  const [waiverReady, setWaiverReady] = useState(false);
  const [waiver, setWaiver] = useState();
  const [waiverBody, setWaiverBody] = useState();
  const [formattedWaiverBody, setFormattedWaiverBody] = useState();

  const getInventoryEventFn = async () => {
    getPublicEventWaiver(eventId).then(result => {
      setWaiver(result);
      setWaiverBody(result?.waiverBody);
      setWaiverReady(true);
    });

    getInventoryEvent(eventId).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEvent(result);
        setEventReady(true);
      }
    });
  }

  const [formInvalid, setFormInvalid] = useState(false);
  const [waiverResponse, setWaiverResponse] = useState();

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(user),
  });

  const {fields, append, remove} = useFieldArray({
    control,
    name: "guests"
  });

  const addGuest = () => {
    append({...guests})
  }

  useEffect(() => {
    addGuest();
  }, []);

  const formContainerRef = useRef(null);
  const esigRefs = useRef({});
  const [esigMounts, setEsigMounts] = useState([]);

  useEffect(() => {
    const container = formContainerRef.current;
    if (!container) {
      setEsigMounts([]);
      return;
    }
    const nodes = Array.from(container.querySelectorAll('[data-esig-mount]'));
    esigRefs.current = {};
    setEsigMounts(nodes.map((node) => ({
      name: node.dataset.esigMount,
      required: node.dataset.esigRequired === '1',
      node,
    })));
  }, [waiverBody, stepTwo]);

  const [saving, setSaving] = useState(false);
  const handleWaiverSubmit = async (e) => {

    for (const mount of esigMounts) {
      const field = esigRefs.current[mount.name];
      if (mount.required && field?.isEmpty()) {
        field.showError();
        setContext({...context, error: {message: 'Please provide your signature before submitting.'}});
        return;
      }
    }

    setSaving(true);
    const formData = {};
    const form = document.getElementById('waiverForm');

    const elements = form.elements;
    for (let j in elements) {
      if (!elements[j].className?.match('replacement')) {
        continue;
      }
      if (!elements[j].value) {
        continue;
      }
      formData[elements[j].name] = elements[j].value;
    }

    const saveData = {
      waiver: waiver,
      formUser: user,
      formData: formData,
      guests: guests,
      eventGuid: event.guid
    }

//    setAppCookie('WAIVER_DATA_USER_' + event?.guid, JSON.stringify(user));

    submitGuestWaiver(saveData).then(result => {
      setSaving(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {

        setUserContext({...userContext, refreshIdentity: true})

        setStepOne(false);
        setStepTwo(false);
        setStepThree(true);

        setWaiverResponse(result);

        let _c = {...context};
        _c.toast = {message: 'Waiver submitted successfully'};
        setContext({..._c});

        setTimeout(() => {
          setContext({...context, toast: {}});
        }, CONSTANTS.TOAST_TIMEOUT);
      }

    });

  }

  const formatReplacements = (html, replacement, placeholder, type) => {
    let _html = html;
    const pattern = '{' + replacement + '}';

    const regex = new RegExp(pattern, 'g');

    let matches = _html.match(regex);

    if (!matches) {
      return _html;
    }

    matches.forEach((item, index) => {
      let isCheck = replacement.match('checkbox');
      let defaultValue = isCheck ? 'Yes' : '';
      let isRequired = true;
      if (item.match('conditional')) {
        isRequired = false;
      }
      let styles = isCheck ? "position:relative;top:5px;" : "";
      let classNames = isCheck ? "replacement form-check d-inline w-auto" : "replacement form-control d-inline w-auto";
      if ('esignature' === type) {
        _html = _html.replace(item, '<div class="esignature-mount" data-esig-mount="' + replacement + '-' + index
          + '" data-esig-required="' + (isRequired ? '1' : '0') + '"></div>');
      } else if ('textarea' === type) {
        _html = _html.replace(item, '<textarea required value="' + defaultValue + '" placeholder="'
          + placeholder + '" type="' + type + '" name="' + replacement + '-' + index + '" class="replacement form-control d-block auto" rows="4"></textarea>');
      } else {
        if (isRequired) {
          _html = _html.replace(item, '<input required value="' + defaultValue + '" placeholder="'
            + placeholder + '" type="' + type + '" name="' + replacement + '-' + index + '" class="replacement" />');
        } else {
          _html = _html.replace(item, '<input onchange="this.value = this.checked ? \'Yes\' : \'No\';" value="No" placeholder="'
            + placeholder + '" type="' + type + '" name="' + replacement + '-' + index + '" class="replacement" />');
        }
      }
    });

    return _html;
  }

  const formItems = [
    {icon: "person", label: "First Name", replacement: "firstName", type: "input"},
    {icon: "person", label: "Last Name", replacement: "lastName", type: "input"},
    {icon: "person", label: "Full Name", replacement: "fullName", type: "input"},
    {icon: "person", label: "Parent / Guardian Name", replacement: "legal-name", type: "input"},
    {icon: "person_add", label: "Child", replacement: "childName", type: "input"},
    {icon: "person_add", label: "Child", replacement: "child-name", type: "input"},
    {icon: "check_box", label: "Agree", replacement: "checkbox-agree", type: "checkbox"},
    {icon: "check_box_outline_blank", label: "Opt-In", replacement: "checkbox-conditional", type: "checkbox"},
    {icon: "app_registration", label: "E-Signature", replacement: "e-signature", type: "esignature"},
    {icon: "notes", label: "Answer", replacement: "answer", type: "input"},
    {icon: "edit", label: "Signature", replacement: "signature", type: "text"},
    {icon: "event", label: "Date", replacement: "date", type: "date"},
    {icon: "event_note", label: "Comment", replacement: "message", type: "textarea"},
    {icon: "event", label: "Current Date", replacement: "currentDate", type: "date"},
  ];
  const toForm = (html) => {
    let _html = html;
    for (let j in formItems) {
      let item = formItems[j];
      _html = formatReplacements(_html, item.replacement, item.label, item.type);
    }
    return _html;
  }

  const handleStepOne = (data) => {
    setUser(data);
    setGuests(data?.guests);
    setStepOne(false);
    setStepTwo(true);
  }

  // useEffect(() => {
  //   const cookieUser = getCookie('WAIVER_DATA_USER_' + eventId);
  //   if (cookieUser) {
  //     let _c = JSON.parse(cookieUser);
  //     setUser(_c);
  //   }
  // }, []);


  return (

    <>
      <CustomerPageLayout>

        <CustomerHeader props={props}/>

        <Meta pageTitle={(event?.name || 'Event') + ' Registration'}/>

        <Grid container>
          <Grid item sm={12} xs={12}>
            {eventReady &&

              <MDBox py={3}>
                <>
                  <center>
                    <h2>Event Waiver</h2>
                    <h3>{event.name}</h3>
                  </center>

                  <MDBox>
                    <MDBox>

                      <Grid container cols={1} direction="row">
                        <Grid item xs={12} sm={12}>
                          <Card>
                            <CardContent>
                              <center>
                                <MDTypography variant="h5" color="secondary" fontWeight="light">
                                  Assigned Waiver - {waiver?.waiverName}
                                </MDTypography>
                              </center>
                              {stepOne && <form
                                onChange={(e) => setFormInvalid(!!!checkFormValidity(e))}
                                onSubmit={handleSubmit(handleStepOne)} id={'customerForm'}>
                                <Grid container justifyContent={'center'}>

                                  <Grid item xs={12} sm={6}>

                                    <h5>Adult</h5>

                                    <Row className={'my-4'}>
                                      <Col sm={6}>
                                        <MDInput type="text" required
                                                 InputLabelProps={{shrink: true}}
                                                 {...register('firstName')}
                                                 autoComplete="off"
                                                 variant="outlined"
                                                 className="form-control" id="firstName"
                                                 placeholder="Enter Adult First Name"
                                                 label="Adult First Name"/>
                                      </Col>
                                      <Col sm={6}>
                                        <MDInput type="text" required
                                                 InputLabelProps={{shrink: true}}
                                                 {...register('lastName')}
                                                 autoComplete="off"
                                                 variant="outlined"
                                                 className="form-control" id="lastName"
                                                 placeholder="Enter Adult Last Name"
                                                 label="Adult Last Name"/>
                                      </Col>

                                    </Row>
                                    <Row className={'my-4'}>
                                      <Col sm={6}>
                                        <MDInput type="email" required
                                                 InputLabelProps={{shrink: true}}
                                                 {...register('email')}
                                                 autoComplete="off"
                                                 variant="outlined"
                                                 placeholder="Enter Email"
                                                 className="form-control" id="email"
                                                 label="Email"/>

                                      </Col>
                                    </Row>


                                    <Divider/>
                                    <h5>Children</h5>
                                    {fields.map((item, index) => (
                                      <Row key={item.id} className={'my-4'}>
                                        <Col sm={6}>
                                          <MDInput
                                            variant="outlined" type="text"
                                            autoComplete="off" required
                                            InputLabelProps={{shrink: true}}
                                            {...register(`guests.${index}.firstName`)}
                                            autoComplete="off"
                                            className="form-control" id="firstName"
                                            label="First Name"
                                            placeholder="Enter First Name"/>

                                        </Col>
                                        <Col sm={6}>
                                          <MDInput
                                            variant="outlined" type="text"
                                            autoComplete="off" required
                                            InputLabelProps={{shrink: true}}
                                            {...register(`guests.${index}.lastName`)}
                                            autoComplete="off"
                                            className="form-control" id="lastName"
                                            label="Last Name"
                                            placeholder="Enter Last Name"/>
                                        </Col>
                                      </Row>
                                    ))}

                                    <div style={{
                                      margin: '10px 0',
                                      display: 'block',
                                      clear: 'both',
                                    }}>
                                      <MDButton type="submit" color="secondary"
                                                onClick={() => {
                                                  addGuest()
                                                }}>
                                        Add Child
                                      </MDButton>
                                    </div>
                                    <div style={{
                                      margin: '10px 0',
                                      display: 'block',
                                      clear: 'both',
                                    }}>
                                      <Divider/>
                                    </div>

                                    <div style={{
                                      display: 'block',
                                      clear: 'both',
                                      margin: '10px 0',
                                    }}>
                                      <MDButton type="submit" color="info" className={'pull-right'}>
                                        Continue
                                      </MDButton>
                                    </div>
                                  </Grid>
                                </Grid>
                              </form>
                              }

                              {waiverReady && stepTwo &&
                                <MDBox mt={3}>
                                  {waiverBody && <form id="waiverForm" onSubmit={(e) => {
                                    e.preventDefault();
                                    handleWaiverSubmit(e);
                                  }}>
                                    <span
                                      ref={formContainerRef}
                                      dangerouslySetInnerHTML={{__html: toForm(waiverBody)}}></span>
                                    {esigMounts.map((mount) => createPortal(
                                      <EsignatureField
                                        key={mount.name}
                                        name={mount.name}
                                        required={mount.required}
                                        ref={(inst) => {
                                          if (inst) {
                                            esigRefs.current[mount.name] = inst;
                                          } else {
                                            delete esigRefs.current[mount.name];
                                          }
                                        }}
                                      />,
                                      mount.node
                                    ))}
                                    <div className="row">
                                      <div className="col col-12">
                                        <MDButton type="submit" color="info" disabled={saving}>
                                          {saving ? 'Saving' : 'Save'}
                                        </MDButton>
                                      </div>
                                    </div>
                                  </form>}
                                  <hr/>
                                  {formattedWaiverBody &&
                                    <div dangerouslySetInnerHTML={{__html: formattedWaiverBody}}></div>}
                                </MDBox>}
                              <br/>
                              {stepThree &&
                                <div>
                                  <center><h5>Thank you, your waiver has been submitted successfully.</h5>
                                  </center>
                                  <div dangerouslySetInnerHTML={{__html: waiverResponse?.waiverBody}}></div>
                                </div>}
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </>

              </MDBox>
            }
          </Grid>
        </Grid>

        <Footer/>
      </CustomerPageLayout>
    </>
  );
}
